import script from "./WarehouseDashboardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehouseDashboardComponent.vue?vue&type=script&setup=true&lang=js"

import "./WarehouseDashboardComponent.vue?vue&type=style&index=0&id=7c6c2783&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6c2783"]])

export default __exports__